import styled from 'styled-components';
import Button from 'core/ui/Button';
import { resetBtn } from 'styled-manila';
import { getColor, StyleVars, typeScale } from 'core/utils';

export const Wrapper = styled.div`
	padding: 24px 0;
	border-bottom: 1px solid ${getColor("gray2")};
	position: relative;

	@media(max-width: ${StyleVars.screenSm}) {
		padding-top: ${typeScale(2)};
		padding-bottom: ${typeScale(2)};
	}
`;

export const Title = styled.h4`
	margin: 0;
	font-weight: 600;
	font-size: 16px;
	line-height: 1.2;
	letter-spacing: 0.2px;
	margin-bottom: ${typeScale(1)};
	color: ${getColor("gray")};
	width: calc(100% - 22px);
`;

export const Date = styled.h6`
	margin-top: 0;
	font-size: 14px;
	line-height: 18px;
	letter-spacing: 0.24px;
	font-weight: 400;
	color: ${getColor('dustyGray')};
	@media(max-width: ${StyleVars.screenSm}) {
		margin-bottom: 0;
	}
`;

export const VerifiedWrapper = styled.div`
	display: inline-flex;
	align-items: center;
	padding: ${typeScale(1)} ${typeScale(2)};
	background: ${getColor("porcelain")};
	border-radius: 16px;
`;

export const VerifiedText = styled.h6`
	margin: 0;
	font-weight: 600;
	font-size: 14px;
	line-height: 14px;
	letter-spacing: 0.2px;
	color: ${getColor('lavender')};
	margin-left: ${typeScale(1)};
`;

export const HelpfulWrapper = styled.div`
	margin-right: ${typeScale(1)};
`;

export const FlagWrapper = styled.div`
	margin-right: ${typeScale(1)};
	margin-left: auto;
`;

export const FlagButton = styled.a`
	color: ${getColor("black")};
	text-decoration: underline;
	padding: 0 16px;

	&:hover {
		color: ${getColor("gray10")};
	}
`;


export const ThanksText = styled.div`
	line-height: 32px;
	color: ${getColor("malachite")};
`;

export const Spacer = styled.span`
	color: ${getColor("gray4")};
	margin: 0 8px;
`;

export const MetaWrapper = styled.div`
	margin-top: ${typeScale(2)};

	@media(max-width: ${StyleVars.screenSm}) {
		margin-top: ${typeScale(1.5)};
	}
`;

export const MetaText = styled.div`
	font-size: 12px;
	line-height: 18px;
	letter-spacing: 0.24px;
	font-weight: 600;
	color: ${getColor('dustyGray')};
`;

export const MetaActions = styled.div`
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	margin-top: ${typeScale(3)};

	@media(max-width: ${StyleVars.screenSm}) {
		margin-top: ${typeScale(1)};
	}
`;

export const Ratings = styled.div`
	margin: 0;
	@media (min-width: ${StyleVars.screenSm}) {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		margin: ${typeScale(1)} 0;
	}
`;

export const EditReviewContainer = styled.div`
	display: ${props => props.hovered ? 'flex' : 'none'};
	position: absolute;
	right: 8px;
	cursor: pointer;
	margin-top: 11px;
	width: 16px;
	height: 16px;
`;

export const ReviewAdminButton = styled.button`
	${resetBtn}
	margin-left: 5px;
`;

export const ReviewAdminLink = styled.a`
	margin-left: 5px;
`;

export const InlineEditButtonWrapper = styled.div`
	display: flex;
	flex-flow: row wrap;
`;

export const HelpButton = styled(Button)`
	line-height: 1;
	svg {
		margin-right: 13px;
	}
`;
